import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14cc8d3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "work" }
const _hoisted_2 = { class: "mod_wrap" }
const _hoisted_3 = { class: "mod_c_title" }
const _hoisted_4 = { class: "mod_c_tbody select_none" }

import { computed } from 'vue';
import Crumb from '@/components/Crumb.vue';
import { RollbackOutlined } from '@ant-design/icons-vue';
import { useRoute } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();

const childrenPageList = ['LuckyCard', 'LuckyCardRecord', 'LuckyRecord'];
const isShowBlack = computed(() => childrenPageList.includes(route.name as string));

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, _toDisplayString(_unref(route).meta?.title), 1),
        _withDirectives(_createVNode(_component_router_link, { to: { name: 'FiveLuckyGame' } }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, null, {
              icon: _withCtx(() => [
                _createVNode(_unref(RollbackOutlined))
              ]),
              default: _withCtx(() => [
                _createTextVNode("返回列表 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _unref(isShowBlack)]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}
}

})